import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import LogoIcon from '!!@svgr/webpack!media/logo.svg'

const Logo = ({ inverted, className }) => {
  return (
    <LogoIcon
      className={cn('c-logo', { 'c-logo--inverted': inverted }, className)}
    />
  )
}

Logo.propTypes = {
  inverted: PropTypes.bool,
  className: PropTypes.string,
}

Logo.defaultProps = {
  inverted: false,
}

export default Logo
